<template>
  <div class="clearfix">
    <div
      id="cpCommentSubmitModal"
      ref="cpCommentSubmitModal"
      class="reveal cp-comment-submit-modal"
      data-reveal
    >
      <!-- <div class="notify-msg" v-if="designDocsChanged">{{ $t('tenantProjects.submission.designDocChanged') }}</div> -->
      <div
        v-if="designDocsChanged || !canDocsAbleToSubmit"
        class="notify-msg"
      >
        {{ $t('tenantProjects.submission.designDocChanged') }}
      </div>
      <label class="cp-review-title">{{ $t('tenantProjects.submission.batchStatus') }}</label>
      <div
        id="design-comment-status"
        class="tender-confirm clearfix"
      >
        <div class="radio-item">
          <input
            id="comment-disapprove"
            v-hkldinput
            name="type"
            type="radio"
            class="radioClass"
            :checked="designComment.comment === DesignBatchStatus.DISAPPROVE"
            @click="event =>updateCommentRadio(DesignBatchStatus.DISAPPROVE)"
          >
          <label
            class="radio-label"
            for="comment-disapprove"
          >
            {{ actionTexts.DISAPPROVE }}
          </label>
        </div>

        <div class="radio-item">
          <input
            id="proceed-no-follow-up"
            v-hkldinput
            name="type"
            type="radio"
            class="radioClass"
            :checked="designComment.comment === DesignBatchStatus.PROCEED_NO_FOLLOW_UP"
            @click="event =>updateCommentRadio(DesignBatchStatus.PROCEED_NO_FOLLOW_UP)"
          >
          <label
            class="radio-label"
            for="proceed-no-follow-up"
          >
            {{ actionTexts.PROCEED_NO_FOLLOW_UP }}
          </label>
        </div>

        <div class="radio-item">
          <input
            id="proceed-cp-follow-up"
            v-hkldinput
            name="type"
            type="radio"
            class="radioClass"
            :checked="designComment.comment === DesignBatchStatus.PROCEED_CP_FOLLOW_UP"
            @click="event =>updateCommentRadio(DesignBatchStatus.PROCEED_CP_FOLLOW_UP)"
          >
          <label
            class="radio-label"
            for="proceed-cp-follow-up"
          >
            {{ actionTexts.PROCEED_CP_FOLLOW_UP }}
          </label>
        </div>
      </div>

      <div class="row align-right nav_btn">
        <button
          id="confirm_no"
          type="button"
          class="btn btn--darkblue"
          @click="rollbackDesignCommentAndCloseModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          id="confirm_ok"
          type="button"
          class="btn btn--orange"
          @click="submit()"
        >{{ $t('action.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import EventBus from '@/utils/eventBus'
import { actionTexts } from './consts'
import { mapGetters, mapActions } from 'vuex'
import { DesignBatchStatus } from '@/utils/locale'

export default {
  name: 'CpCommentSubmitModal',
  props: {
    confirmCallback: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      canDocsAbleToSubmit: true,
      designDocsChanged: false,
      DesignBatchStatus,
      inputRequireHighlight: false,
      initialDesignComment: '',
    }
  },
  computed: {
    ...mapGetters('tenantProject', ['currentTenantProject', 'currentTenantProjectDocs', 'currentTenantSubmission']),
    designComment () {
      return lodash.get(this.currentTenantSubmission, 'designComment', {})
    },
    actionTexts () {
      return actionTexts()
    },
  },
  beforeDestroy () {
    if (this.cpCommentSubmitModal) {
      this.cpCommentSubmitModal.destroy()
    }
    $(this.$refs.cpCommentSubmitModal).remove()
  },
  methods: {
    ...mapActions('tenantProject', ['updateCurrentStateSubmissionByPath', 'loadTenantProjectsDocs', 'loadTenantProject']),
    async init () {
      if (!this.cpCommentSubmitModal) {
        this.cpCommentSubmitModal = await new Foundation.Reveal($('#cpCommentSubmitModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
    },
    async openModal () {
      this.designDocsChanged = false
      if (await this.validateDesignDocsChange()) {
        this.designDocsChanged = true
      }
      await this.loadTenantProject(this.currentTenantProject.id)
      await this.init()

      this.initialDesignComment = this.designComment.comment
      this.cpCommentSubmitModal.open()
    },
    closeModal () {
      if (this.cpCommentSubmitModal) {
        this.cpCommentSubmitModal.close()
      }
    },
    async submit () {
      if (!this.validate()) {
        return
      }
      await this.validateDocs()
      if (!this.canDocsAbleToSubmit) {
        return
      }
      await this.confirmCallback(undefined)
      this.closeModal()
    },
    updateCommentRadio (commentType) {
      this.updateGlobalDesignComment({
        ...this.designComment,
        comment: this.designComment.comment === commentType ? '' : commentType,
      })
    },
    rollbackDesignComment () {
      if (this.initialDesignComment === this.designComment.comment) {
        return
      }
      this.updateGlobalDesignComment({
        ...this.designComment,
        comment: this.initialDesignComment,
      })
    },
    rollbackDesignCommentAndCloseModal () {
      this.rollbackDesignComment()
      this.closeModal()
    },
    updateGlobalDesignComment (designComment) {
      this.updateCurrentStateSubmissionByPath({
        path: ['designComment'],
        newValue: designComment,
      }, designComment)
    },
    validate () {
      if (!this.designComment.comment) {
        $('#design-comment-status .radio-item').addClass('fusion-input-check-is-invalid-input')
        return false
      } else {
        this.resetValidation()
        return true
      }
    },
    async validateDesignDocsChange () {
      let isDesignChange = false

      const oldDocs = lodash.cloneDeep(this.currentTenantProjectDocs)
      const oldDesignDocIds = oldDocs.filter(doc => doc.batchNum !== null && Number(doc.batchNum) === Number(this.currentTenantSubmission.order) && doc.metaData && doc.metaData.submitted && doc.metaData.isDesign).map(doc => doc.id)

      await this.loadTenantProjectsDocs({projectDocsSrcId: this.currentTenantProject.projectDocsSrcId})

      const newTenantProjectDocs = this.currentTenantProjectDocs
      const newDesignDocIds = newTenantProjectDocs.filter(doc =>
        (doc.batchNum !== null && Number(doc.batchNum) === Number(this.currentTenantSubmission.order)) &&
        doc.metaData && doc.metaData.submitted && doc.metaData.isDesign).map(doc => doc.id)

      newDesignDocIds.forEach(id => {
        if (!oldDesignDocIds.includes(id)) {
          isDesignChange = true
        }
      })

      if (!this.canDocsAbleToSubmit) {
        oldDesignDocIds.forEach(id => {
          if (!newDesignDocIds.includes(id)) {
            isDesignChange = true
          }
        })
      }
      if (isDesignChange) {
        EventBus.$emit('tenant_docs_refresh')
      }
      return isDesignChange
    },
    async validateDocs () {
      this.canDocsAbleToSubmit = true
      if ([DesignBatchStatus.PROCEED_CP_FOLLOW_UP, DesignBatchStatus.DISAPPROVE].includes(this.designComment.comment)) {
        return this.canDocsAbleToSubmit
      }
      this.canDocsAbleToSubmit = !await this.validateDesignDocsChange()
    },
    resetValidation () {
      $('#design-comment-status .radio-item').removeClass('fusion-input-check-is-invalid-input')
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
@import '~styles/popup';
</style>

<style lang="scss">
$tender-font-color: #0C3A58;
#cpCommentSubmitModal {
  width: 500px;
  .cp-review-title {
    text-transform: capitalize;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 1.43;
    font-weight: bold;
    text-align: left;
    color: $tender-font-color;
  }
  .tender-confirm label {
    font-weight: normal;
  }
  .notify-msg {
    color: #ae7001;
    margin-top: 10px;
  }
}
</style>
